/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { GatewayFaultPaymentProblemJson } from "./GatewayFaultPaymentProblemJson";
import { ValidationFaultPaymentUnavailableProblemJson } from "./ValidationFaultPaymentUnavailableProblemJson";

export const NodeProblemJson502 = t.union(
  [
    GatewayFaultPaymentProblemJson,

    ValidationFaultPaymentUnavailableProblemJson
  ],
  "NodeProblemJson502"
);

export type NodeProblemJson502 = t.TypeOf<typeof NodeProblemJson502>;
